const FinetuneSuggestionListColumn = [
  {
    title: 'Job ID',
    dataIndex: 'id',
    width: 300,
    slot: 'jobId'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    width: 120,
    slot: 'status'
  },
  {
    title: 'Analysis window',
    dataIndex: 'start_datetime',
    width: 250,
    slot: 'analysisWindow'
  },
  {
    title: 'Created',
    dataIndex: 'created_at',
    width: 170,
    slot: 'created_at'
  },
  {
    title: 'Completed',
    dataIndex: 'completed_at',
    width: 170,
    slot: 'completed_at'
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];

export { FinetuneSuggestionListColumn };
